<template>
  <div v-if="isLoading" class="loading-overlay">
    <div class="spinner-container">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import { loadingEventBus } from '@/utils/loadingEventBus';

export default {
  name: 'LoadingOverlay',
  data() {
    return {
      isLoading: false
    }
  },
  created() {
    loadingEventBus.on('loading:show', () => {
      this.isLoading = true;
    });

    loadingEventBus.on('loading:hide', () => {
      this.isLoading = false;
    });
  },
  beforeUnmount() {
    loadingEventBus.off('loading:show', this.show);
    loadingEventBus.off('loading:hide', this.hide);
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #195983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
